import Lottie from 'lottie-react';
import { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';

import AppLoader from '~assets/loader.json';
import { ALL_ROUTES } from './routesConfig';

const AppRoutes = () => {
  const element = useRoutes(ALL_ROUTES);

  return (
    <Suspense
      fallback={
        <div className="loading_container">
          <Lottie animationData={AppLoader} loop />
        </div>
      }
    >
      {element}
    </Suspense>
  );
};

export default AppRoutes;
